import { View } from "@pimo/pimo-app-builder";
import {
  DragAndDropLayout,
  PMBarChartCard,
  PMDonutChartCard,
} from "@pimo/pimo-components";

import { TestAppState } from "../../../app";
import { DONUT_CARD_LAYOUT } from "../../../constants";
import {
  getAllReportingItems,
  getLifeCycleData,
  withTotalInTitle,
} from "../get-dashboard-chart-data";

/**
 * Adds the "systems per life cycle" bar and donut chart cards, in that order
 * (#2222).
 */
export function addLifeCycleDashboardCards(
  view: View<TestAppState, DragAndDropLayout>
) {
  const lifeCycleBarChartComponent = view.addComponent({
    component: PMBarChartCard,
    layoutProps: {
      componentId: "lifeCycleDashboardBarChartComponent",
      labels: ["barChart", "chart", "lifeCycle"],
      description: "Shows systems grouped by life cycle across all projects.",
      title: "Systems per Life Cycle",
    },
  });

  lifeCycleBarChartComponent.mapState(({ dashboard }) => {
    const allItems = getAllReportingItems(dashboard);
    const { entries } = getLifeCycleData(allItems);

    return {
      title: "Systems per Life Cycle",
      categories: entries.map((entry) => entry.label),
      data: entries.map((entry) => entry.count),
      chartType: 1 as const,
      xLabel: "Systems",
      yLabel: "Life Cycle",
      colors: entries.map((entry) => entry.color),
      fixedHeight: "320px",
    };
  });

  const lifeCycleDonutChartComponent = view.addComponent({
    component: PMDonutChartCard,
    layoutProps: {
      componentId: "lifeCycleDashboardDonutChartComponent",
      labels: ["donutChart", "chart", "lifeCycle"],
      description: "Shows systems grouped by life cycle across all projects.",
      title: "Systems per Life Cycle",
    },
  });

  lifeCycleDonutChartComponent.mapState(({ dashboard }) => {
    const allItems = getAllReportingItems(dashboard);
    const { entries } = getLifeCycleData(allItems);

    return {
      title: withTotalInTitle("Systems per Life Cycle", allItems.length),
      icon: "DonutLarge",
      ...DONUT_CARD_LAYOUT,
      data: entries.map((entry) => ({
        label: entry.label,
        value: entry.count,
        color: entry.color,
      })),
    };
  });
}
